<ng-container *ngIf="isMobile; else desktopTemplate">
  <div
    class="documents"
    infiniteScroll
    [scrollWindow]="true"
    [infiniteScrollDistance]="0.8"
    (scrolled)="onScroll()"
  >
    <div
      class="document-info"
      *ngFor="let document of documents"
      (click)="downloadPdf(document)"
    >
      <img class="document-image" [src]="document.thumbUrlMobile" alt="Thumb" />
      <span class="document-tag">PDF</span>
      <div class="document-details">
        <img
          class="document-icon"
          *ngIf="
            document.specie === PetTypeEnum.DOG ||
            document.specie === PetTypeEnum.BOTH
          "
          src="../../../../assets/icons/dog.png"
          alt="Cão"
        />
        <img
          class="document-icon"
          *ngIf="
            document.specie === PetTypeEnum.CAT ||
            document.specie === PetTypeEnum.BOTH
          "
          src="../../../../assets/icons/cat.png"
          alt="Gato"
        />
        <div class="document-button">
          <i class="bi bi-download"></i>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #desktopTemplate>
  <div class="documents">
    <div
      class="document-info"
      *ngFor="let document of documents"
      (click)="clickInfor(document)"
    >
      <img class="document-image" [src]="document.thumbUrl" alt="Thumb" />
      <span class="document-tag">PDF</span>
      <div class="document-details">
        <img
          class="document-icon"
          *ngIf="
            document.specie === PetTypeEnum.DOG ||
            document.specie === PetTypeEnum.BOTH
          "
          src="../../../../assets/icons/dog-transparent.svg"
          alt="Cão"
        />
        <img
          class="document-icon"
          *ngIf="
            document.specie === PetTypeEnum.CAT ||
            document.specie === PetTypeEnum.BOTH
          "
          src="../../../../assets/icons/cat-transparent.svg"
          alt="Gato"
        />
        <div class="document-button">
          <span>Acessar</span>
          <i class="bi bi-arrow-right-short"></i>
        </div>
      </div>
    </div>
  </div>
  <p-paginator
    [totalRows]="totalDocuments"
    [maxRowsPerPage]="itensPerPage"
    [currentPage]="pageNumber"
    (currentPageChange)="onPageChange($event)"
    [ngStyle]="{ display: documents.length === 0 ? 'none' : 'block' }"
  >
  </p-paginator>
</ng-template>
